/* eslint camelcase: 0 */

import { Model, createMessages } from '@/helpers/Model'


export class DashboardCollectorModel extends Model<unknown> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    index: 'Информационная панель',
  });
}
